<div class="ngmodal modal--advisor check-coverage">
    <div class="ngmodal-header">
      <button mat-button mat-dialog-close><span class="icon-close "></span></button>
    </div>
    <div class="ngmodal-body">
      <h3 class="check-coverage__title">Confirma tu teléfono</h3>
      <p class="check-coverage__text">Antes de continuar debemos hacer una actualización de datos para temas de facturación, por favor ingresa tu número de teléfono.</p>
      <form [formGroup]="phoneValidator" #signUpFormV="ngForm">
        <div class="error-text-span" *ngIf="isFailUpdateInfo">
          <span> {{msgsPhoneError.service}} </span>
        </div>
      <mat-form-field appearance="outline" class="input-telephone mt-base">
        <mat-label>Teléfono</mat-label>
        <input matInput placeholder="Escribe tu telefono" type="number" formControlName="phone" class="width-100" autocomplete="off" spellcheck="false" required>
        <mat-hint>
          <span class="error-hint" *ngIf="(form.phone.dirty) && form.phone.invalid && form.phone.errors.required">
            {{msgsPhoneError.required}}
          </span>
          <span class="error-hint" *ngIf="(form.phone.dirty) && form.phone.invalid && form.phone.errors.max">
            {{msgsPhoneError.min}}
          </span>
          <span class="error-hint" *ngIf="(form.phone.dirty) && form.phone.invalid && form.phone.errors.min">
            {{msgsPhoneError.max}}
          </span>
        </mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline" class="input-telephone mt-none">
        <mat-label>Celular</mat-label>
        <input matInput placeholder="Escribe tu celular" type="number" formControlName="cellphone" class="width-100" autocomplete="off" spellcheck="false" required>
        <mat-hint>
          <span class="error-hint" *ngIf="(form.cellphone.dirty) && form.cellphone.invalid && form.cellphone.errors.required">
            {{msgsCellPhoneError.required}}
          </span>
          <span class="error-hint" *ngIf="(form.cellphone.dirty) && form.cellphone.invalid && form.cellphone.errors.max">
            {{msgsCellPhoneError.min}}
          </span>
          <span class="error-hint" *ngIf="(form.cellphone.dirty) && form.cellphone.invalid && form.cellphone.errors.min">
            {{msgsCellPhoneError.max}}
          </span>
        </mat-hint>
      </mat-form-field>

     <div class="check-coverage__buttons">
        <button type="submit" class="button secondary rounded width-80" (click)='actualizateDate()'>CONFIRMAR</button>
     </div>
    </form>
    </div>
</div>